import React, { useState } from "react";
import { Modal, Form, Row, Col, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { notify } from "../actions/CommonActions";
import { createMemberApi, createPolicyApi, createUser } from "../../services";

export const NewMemberModal = ({ showUser, toggleShowUser, id, refetch }) => {
  const [register, setRegister] = useState({});
  const [isRegistering, setIsRegistering] = useState(false);
  const [step, setStep] = useState(1);
  const [fillFields, setFillFields] = useState(false);
  const navigate = useNavigate();

  const handleRegisterChange = (e) => {
    const { name, value } = e.target;
    setRegister((prev) => ({ ...prev, [name]: value }));
  };

  const validateCurrentStep = () => {
    const requiredStep1 = [
      "name",
      "address",
      "email",
      "dob",
      "gender",
      // "occupation",
    ];

    const requiredStep2 = [
      "insuredNumber",
      "phoneNumber",
      "employmentStatus",
      // "policyNumber",
    ];


    const requiredFields =
      step === 1 ? requiredStep1 : requiredStep2 ;

    for (let field of requiredFields) {
      if (!register[field]?.toString().trim()) {
        return false;
      }
    }
    return true;
  };

  const CreateUserCall = async (values) => {
    setIsRegistering(true);
    // values.policyNumber = Number(values.policyNumber)
    values.insuredNumber = Number(values.insuredNumber)
    values.policyNumber = id

    delete values.emailAddress

    await createMemberApi(values)
      .then((res) => {
        notify("success", "Policy created.", res?.message);
        setRegister({});
        setStep(1);
        setIsRegistering(false);
        toggleShowUser();
        refetch();
      })
      .catch((error) => {
        notify("danger", "OOPS", error?.response?.data?.message);
        setIsRegistering(false);
      });
  };

  return (
    <Modal show={showUser} onHide={toggleShowUser} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>New Policy</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "50%",
            margin: "auto",
          }}
        >
          {[1, 2].map((s, i) => (
            <React.Fragment key={`step-${s}`}>
              <div
                style={{
                  background: s <= step ? "#007dcc" : "#DCDCDC",
                  width: "25px",
                  height: "25px",
                  borderRadius: "50%",
                  color: s <= step ? "white" : "black",
                  alignItems: "center",
                  justifyContent: "center",
                  display: "flex",
                  fontSize: "14px",
                }}
              >
                {s}
              </div>
              {i < 1 && (
                <div
                  style={{
                    flex: 1,
                    backgroundColor: s < step ? "#007dcc" : "#DCDCDC",
                    height: "3px",
                  }}
                />
              )}
            </React.Fragment>
          ))}
        </div>

        <Form className="d-flex flex-column gap-3">
          {step === 1 ? (
            <div style={{ marginTop: "20px" }}>
              <Form.Group>
                <Form.Label>Name</Form.Label>
                <Form.Control name="name" onChange={handleRegisterChange} value={register?.name || ""} required />
              </Form.Group>
              <Form.Group>
                <Form.Label>Address</Form.Label>
                <Form.Control name="address" onChange={handleRegisterChange} value={register?.address || ""} required />
              </Form.Group>
              <Form.Group>
                <Form.Label>Email</Form.Label>
                <Form.Control name="email" onChange={handleRegisterChange} value={register?.email || ""} required />
              </Form.Group>
              {/* <Form.Group>
                <Form.Label>Occupation</Form.Label>
                <Form.Control name="occupation" onChange={handleRegisterChange} value={register?.occupation || ""} required />
              </Form.Group> */}
              <Form.Group as={Col}>
                  <Form.Label>Date of birth</Form.Label>
                  <Form.Control type="date" name="dob" value={register?.dob || ""} onChange={handleRegisterChange} required />
                </Form.Group>
              <Form.Group>
  <Form.Label>Gender</Form.Label>
  <Form.Select
    name="gender"
    onChange={handleRegisterChange}
    value={register?.gender || ""}
    required
  >
    <option value="">Select gender</option>
    <option value="Male">Male</option>
    <option value="Female">Female</option>
  </Form.Select>
</Form.Group>
            </div>
          ) : (
            <div style={{ marginTop: "20px" }}>
              <Form.Group>
                <Form.Label>Insured number</Form.Label>
                <Form.Control name="insuredNumber" onChange={handleRegisterChange} value={register?.insuredNumber || ""} required />
              </Form.Group>
              <Form.Group>
                <Form.Label>Phone number</Form.Label>
                <Form.Control name="phoneNumber" onChange={handleRegisterChange} value={register?.phoneNumber || ""} required />
              </Form.Group>
              <Form.Group>
                <Form.Label>Employment status</Form.Label>
                <Form.Control name="employmentStatus" onChange={handleRegisterChange} value={register?.employmentStatus || ""} required />
              </Form.Group>
              
              {/* <Form.Group>
                <Form.Label>Policy number</Form.Label>
                <Form.Control name="policyNumber" placeholder="ABC-DE-2000-12345" onChange={handleRegisterChange} value={register?.policyNumber || ""} required />
              </Form.Group> */}
              <Form.Group>
  <Form.Label>Identification doc</Form.Label>
  <Form.Select
    name="identificationDoc"
    onChange={handleRegisterChange}
    value={register?.identificationDoc || ""}
    required
  >
    <option value="">Select doc type</option>
    <option value="Staff ID">Staff ID</option>
    <option value="National ID">National ID</option>
    <option value="Passport">Passport</option>
    <option value="Driver's License">Driver's License</option>
  </Form.Select>
</Form.Group>
              <Form.Group>
                <Form.Label>identification number</Form.Label>
                <Form.Control name="identificationNumber" onChange={handleRegisterChange} value={register?.identificationNumber || ""} required />
              </Form.Group>
            </div>
          )}

          {fillFields && (
            <p style={{ color: "red", fontWeight: "600" }}>Please fill all fields</p>
          )}

          <div style={{ display: "flex", justifyContent: "space-between" }}>
            {step > 1 && (
              <Button
                onClick={(e) => {
                  e.preventDefault();
                  setStep(step - 1);
                }}
                style={{ backgroundColor: "red", border: "none" }}
                disabled={isRegistering}
              >
                Back
              </Button>
            )}
            <div></div>
            <Button
              onClick={async (e) => {
                e.preventDefault();
                if (!validateCurrentStep()) {
                  setFillFields(true);
                  return;
                } else {
                  setFillFields(false);
                }

                if (step < 2) {
                  setStep(step + 1);
                } else {
                  await CreateUserCall(register);
                }
              }}
              style={{ backgroundColor: "#007dcc" }}
              disabled={isRegistering}
            >
              {isRegistering ? "Creating..." : step == 2 ? "Create Member" : "Next"}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};
